<template>
  <v-container fluid class="pa-0">
    <v-card outlined class="rounded-lg pa-4">
      <div class="d-flex align-center mb-4">
        <v-avatar size="48" class="section-icon mr-3" rounded>
          <v-icon color="white">mdi-folder-multiple-image</v-icon>
        </v-avatar>
        <div>
          <div class="text-subtitle-1 font-weight-bold primary--text">Media Manager</div>
          <div class="text-caption grey--text">Upload and manage images for your school website</div>
        </div>
      </div>

      <v-file-input
        v-model="files"
        label="Upload media files"
        multiple
        show-size
        outlined
        prepend-icon=""
        prepend-inner-icon="mdi-cloud-upload-outline"
        @change="uploadFiles"
      />

      <v-row>
        <v-col v-for="file in media" :key="file.id" cols="6" sm="4" md="3">
          <v-card outlined class="rounded-lg media-card overflow-hidden">
            <v-img :src="file.path" aspect-ratio="1" />
            <v-card-actions>
              <v-spacer/>
              <v-btn icon @click="deleteMedia(file.id)">
                <v-icon color="error">mdi-trash-can-outline</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios';
export default {
  props: ['websiteId'],
  data() {
    return {
      files: [],
      media: [],
    };
  },
  methods: {
    async fetchMedia() {
      const res = await axios.get(`/api/websites/${this.websiteId}/media`);
      this.media = res.data;
    },
    async uploadFiles() {
      for (let file of this.files) {
        let form = new FormData();
        form.append('file', file);
        await axios.post(`/api/websites/${this.websiteId}/media`, form);
      }
      this.files = [];
      this.fetchMedia();
    },
    async deleteMedia(id) {
      await axios.delete(`/api/media/${id}`);
      this.$toast.success('Media deleted');
      this.fetchMedia();
    }
  },
  mounted() {
    this.fetchMedia();
  }
};
</script>

<style scoped>
.section-icon {
    background: linear-gradient(135deg, #1E3C72 0%, #2A5298 100%);
}
.media-card {
    border: 1px solid #ECEFF7;
}
</style>
